import React, { useState } from 'react';
import { Button } from 'reactstrap';
import BookingDetail from './BookingDetail';
export default function DetailButton({
  id, BindData
}) {
  const [isUpdating, setIsUpdating] = useState(false);

  return (
    <div>
      <Button
        color="primary"
        size="xs"
        onClick={() => setIsUpdating(!isUpdating)}
      >
        Detail
      </Button>
      {isUpdating && (
        <BookingDetail
          bookingId={id}
          visible={isUpdating}
          BindData={BindData}
          toggle={() => setIsUpdating(!isUpdating)}
        />
      )}
    </div>
  );
}
